import { Button } from "components/Button";
import { Select } from "components/SelectUI/Select";
import { SortableTable } from "components/SortableTable/SortableTable";
import { StyledCell, StyledHeaderCell } from "components/SortableTable/SortableTable.styled";
import { SvgIconReact } from "components/SvgIconReact";
import type { ThemeProps } from "models/styles/theme";
import styled from "styled-components";
import { ParagraphLarge } from "styles/elements/Texts";
import { calculateRem } from "styles/mixins/calculateRem";

interface Props extends ThemeProps {
  $isExpired?: boolean;
  iconName?: string;
}

interface StatusPillProps extends ThemeProps {
  $variant: string;
}

interface SelectButtonProps extends ThemeProps {
  disabled?: boolean;
  deleteBtn?: boolean;
}

export const StyledSelectAccountsButton = styled(Button)<SelectButtonProps>`
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  color: ${({ theme, deleteBtn }) => (deleteBtn ? theme.palette.red.brand : theme.palette.secondary.brand)};
`;

export const StyledSortableTable = styled(SortableTable)<ThemeProps>`
  margin-top: 0;
  width: 100%;
  overflow: scroll;
  ${StyledHeaderCell} {
    align-items: flex-start;
    justify-content: center;
    background: ${({ theme }: ThemeProps) => theme.palette.neutral._900};
    padding: 0.7rem;
    max-width: 15rem;
  }
  ${StyledCell} {
    background: ${({ theme }: ThemeProps) => theme.palette.neutral._999};
    padding: 0.5rem;
    max-width: 15rem;
    a {
      text-decoration: none;
      color: ${({ theme }: ThemeProps) => theme.palette.neutral.black};
    }
  }
`;

export const StyledProduct = styled(ParagraphLarge)<Props>`
  color: ${({ theme, $isExpired }: Props) => {
    return $isExpired ? theme.palette.red.brand : theme.palette.neutral.black;
  }}
`;

export const StyledStatusPill = styled(ParagraphLarge)<StatusPillProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.3rem 0.6rem;
  font-size: 8px;
  border-radius: ${({ theme }) => theme.borderRadius.roundedPill};
  background: ${({ theme, $variant }) =>
    $variant === "active"
      ? theme.palette.feedback.success.brand
      : theme.palette.feedback.error.brand};
  color: ${({ theme }) => theme.palette.neutral.white};
  text-transform: capitalize;
`;

export const StyledIcon = styled(SvgIconReact)<Props>`
  cursor: pointer;
  color: ${({ theme, iconName }: Props) => (iconName === "trashIcon" ? theme.palette.red.brand : theme.palette.neutral.black)};
`;

export const StyledSelect = styled(Select)`
  height: ${calculateRem(48)};
  margin-left: ${calculateRem(32)};
`;

export const StyledSpinnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
